import { useAuth } from "@app/auth-client";
import { usePortal } from "@app/portal-sdk";
import { Button, EmptyState, Stack, Typography } from "@app/ui-kit";

export const NoAccess = () => {
  const { logout } = useAuth();
  const { me } = usePortal();

  return (
    <Stack spacing={3} sx={{ maxWidth: 640 }}>
      <EmptyState
        eyebrow="No Access"
        title="Your account isn't attached to a client yet"
        description="You are signed in, but no client portal has been shared with this account. If you were invited, check that you signed in with the same email address the invitation was sent to."
        action={
          <Button variant="outlined" onClick={() => void logout()}>
            Sign out
          </Button>
        }
      />
      <Typography variant="caption" sx={{ color: "text.disabled" }}>
        Signed in as {me?.user.email ?? "unknown"}
      </Typography>
    </Stack>
  );
};
